import { useEffect } from "react"
import { type WorkBook } from "xlsx"

interface Props {
    file: File | undefined | null
    setWorkbook: (workbook: WorkBook) => void
    setSheetNames: (sheetNames: string[]) => void
    setSelectedSheet: (sheetName: string) => void
}

export function useWorkbook({ file, setSelectedSheet, setSheetNames, setWorkbook }: Props) {
    useEffect(() => {
        if (!file) {
            return
        }

        import("xlsx").then(({ read }) => {
            const reader = new FileReader()
            reader.readAsArrayBuffer(file)
            reader.onload = function (e) {
                if (e.target?.result) {
                    const wb = read(e.target.result)
                    setWorkbook(wb)
                    setSheetNames(wb.SheetNames)
                    if (wb.SheetNames.length === 1) {
                        setSelectedSheet(wb.SheetNames[0])
                    }
                }
            }
        })
    }, [file, setSelectedSheet, setSheetNames, setWorkbook])
}
